import { Empty, Table, Popover, Badge, Button } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";

import {
  Container,
  // DeadlineItem,
  // DeadLineName,
  // Deadlines,
  DeadlineSkeletonItem,
  // DeadlineSummary,
  // DeadlineSummaryItem,
  // Footer,
  Main,
} from "./styles";

import "./custom-skeleton.css";
import { CustomersModal } from "./CustomersModal";
import { ModuleHeader } from '~/components/ModuleHeader';
import { columns } from "./Columns";
import FilterPillsBar from '~/_shared/components/FilterPillsBar';
import MonthInput from '~/_shared/components/MonthInput';
import RestoredFiltersNotice from '~/_shared/components/RestoredFiltersNotice';
import {
  getDeadlinesMonthLabel,
  isDeadlinesMonthDefault,
  countActiveDeadlinesFilters,
} from "./filters";

export const DocumentsDeadlines = ({ persisted }) => {
  const {
    documentsDeadlines: { list: documentsDeadlines, isLoading },
  } = useSelector((state) => state);

  // The applied month ('YYYY-MM') lives in the screen (usePersistedFilters),
  // which reloads the list whenever it changes.
  const applied = persisted.filters;
  const defaults = persisted.defaults;
  const isMonthDefault = isDeadlinesMonthDefault(applied, defaults);
  const monthLabel = getDeadlinesMonthLabel(applied);
  const clearFilters = () => persisted.resetFilters();

  const [customersModal, setCustomersModal] = useState({
    isVisible: false,
    data: null,
  });

  function showCustomersModal(data) {
    setCustomersModal({
      isVisible: true,
      data,
    });
  }

  function hideCustomersModal() {
    setCustomersModal({
      isVisible: false,
      data: null,
    });
  }

  return (
    <Container>
      <ModuleHeader
          breadcrumbs={['Relatórios', 'Prazos']}
          title="Prazos (impostos)"
          center={
            <Popover
              trigger="click"
              placement="bottomRight"
              content={
                <div style={{ width: 280 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                    <span style={{ fontSize: 15, fontWeight: 600, color: '#262626' }}>Filtros</span>
                    {!persisted.isDefault && (
                      <a
                        style={{ fontSize: 12, color: '#f5222d' }}
                        onClick={clearFilters}
                      >
                        Limpar
                      </a>
                    )}
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <span style={{ fontSize: 12, color: '#8c8c8c', marginBottom: 4, display: 'block' }}>Mês / Ano</span>
                    <MonthInput
                      value={applied.month}
                      onChange={function(value) { persisted.setFilters({ month: value }); }}
                      style={{ width: '100%' }}
                    />
                    <div style={{ fontSize: 11, color: '#bfbfbf', marginTop: 4 }}>
                      Digite o mês (ex.: 03/2026) ou use o calendário.
                    </div>
                  </div>
                </div>
              }
            >
              <Badge
                count={countActiveDeadlinesFilters(applied, defaults)}
                offset={[-4, 0]}
                style={{ backgroundColor: '#722ed1' }}
              >
                <Button icon="bars" style={{ borderRadius: 8 }}>Filtros</Button>
              </Badge>
            </Popover>
          }
          advanced={
            (function() {
              var pills = [];
              pills.push({
                key: 'month',
                label: monthLabel,
                color: isMonthDefault ? '#1890ff' : '#722ed1',
                icon: 'calendar',
                onRemove: isMonthDefault ? undefined : function() { persisted.setFilters({ month: defaults.month }); },
              });
              return React.createElement(FilterPillsBar, {
                pills: pills,
                onClearAll: persisted.isDefault ? undefined : clearFilters,
              });
            })()
          }
      />
      <RestoredFiltersNotice
        visible={persisted.wasRestored}
        summary={monthLabel}
        onReset={clearFilters}
        onDismiss={persisted.dismissRestored}
      />
            <Main>
            {isLoading ? (
              <>
              {Array(6)
                .fill(1)
                .map((_, index) => (
                <DeadlineSkeletonItem key={index} />
                ))}
              </>
            ) : !isLoading && documentsDeadlines.length === 0 ? (
              <Empty
              description="Nenhuma tarefa encontrada."
              style={{ marginTop: 200 }}
              />
            ) : (
                <div className="table-clabs">
                  <Table
                    bordered
                    dataSource={documentsDeadlines}
                    columns={columns()}
                    rowKey="id"
                    onRow={(record) => ({
                      onClick: () => showCustomersModal(record.registers),
                      style: { cursor: 'pointer' },
                    })}
                  />
                </div>
              )}
            </Main>
      <CustomersModal
        isVisible={customersModal.isVisible}
        data={customersModal.data}
        hideCustomersModal={hideCustomersModal}
      />
    </Container>
  );
};
